// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unauthed-about-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex:1 1;
  background-color: rgba(210, 233, 248, 0.116);
}

.unauthed-about-container-title{
 font-size: xx-large;
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Unauthed/About/About.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,QAAM;EACN,4CAA4C;AAC9C;;AAEA;CACC,mBAAmB;AACpB","sourcesContent":[".unauthed-about-container {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  flex:1;\n  background-color: rgba(210, 233, 248, 0.116);\n}\n\n.unauthed-about-container-title{\n font-size: xx-large;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
